import React from "react";
import { FaCircleCheck, FaPaperPlane } from "react-icons/fa6";
import { FaClock } from "react-icons/fa";

export const InvoiceStatusIcon = ({ status }) => {
  if (status === "CREATED") {
    return <FaClock size={19} color={"#e69265"} />;
  }
  if (status === "READY") {
    return <FaCircleCheck size={19} color={"#63e6be"} />;
  }
  if (status === "SENT") {
    return <FaPaperPlane size={19} color={"#74c0fc"} />;
  }
  return <FaClock size={19} color={"#adb5bd"} />;
};
